'use client';

import { LoadingBackground } from '@core/Components/LoadingBackground/LoadingBackground';
import Button from '@gds/Button/Button';
import { Typography } from '@gds/Typography/Typography';
import { CalculatorMessages } from '../Calculator.messages';

import { localeAtom } from '@core/Atoms/Locale/Locale.atom';
import { useAtomValue } from 'jotai';
import styles from './../Calculator.module.css';

export type Props = {
  strings: CalculatorMessages;
  hasReservedStatus?: boolean;
};

export const LoadingSummaryContainer = ({ strings }: Props) => {
  const locale = useAtomValue(localeAtom);

  return (
    <div
      className={`${locale === 'uk' ? styles.summaryContainer : styles.universalSummaryContainer}`}
    >
      <div className={styles.summaryTitle}>
        <Typography variant="h5">
          <LoadingBackground />
        </Typography>

        <Typography variant="body4" Component="p">
          <LoadingBackground />
        </Typography>
      </div>
      <div className={`${locale === 'uk' ? styles.fakeSummary : styles.universalFakeSummary}`}>
        <LoadingBackground />
      </div>
      <div className={styles.ctasContainer}>
        <Button variant="outlined" type="submit" disabled>
          {locale === 'uk' ? strings.startJourney : strings.startUniversalJourney}
        </Button>
      </div>
    </div>
  );
};
